import { CIcon } from '~/icons/types'
export const ciSparkles: CIcon = {
  width: 24,
  height: 24,
  paths: [
    {
      d:
        'm22 11.3-2.8-.8c-1.2-.4-2.2-1.3-2.6-2.6L15.7 5c-.1-.3-.4-.5-.7-.5-.3 0-.6.2-.7.5l-.8 2.8c-.4 1.2-1.3 2.2-2.6 2.6l-2.9.9c-.3.1-.5.4-.5.7 0 .3.2.6.5.7l2.8.8c1.2.4 2.2 1.3 2.6 2.6l.8 2.8c.1.3.4.5.7.5.3 0 .6-.2.7-.5l.8-2.8c.4-1.2 1.3-2.2 2.6-2.6l2.8-.8c.3-.1.5-.4.5-.7 0-.3 0-.6-.3-.7ZM5 8.9l.3 1c.1.3.4.6.7.6.3 0 .6-.2.7-.6l.3-1C7.2 8 8 7.2 8.9 7l1-.3c.3-.1.6-.4.6-.7 0-.3-.2-.6-.6-.7l-1-.3C8 4.8 7.2 4 7 3.1l-.3-1c-.1-.4-.4-.6-.7-.6-.3 0-.6.2-.7.6l-.3 1C4.8 4 4 4.8 3.1 5l-1 .3c-.4.1-.6.4-.6.7 0 .3.2.6.6.7l1 .3C4 7.2 4.8 8 5 8.9ZM10.7 18l-1.2-.4c-.4-.1-.8-.5-.9-.9l-.4-1.2c-.1-.3-.4-.5-.7-.5-.3 0-.6.2-.7.5l-.4 1.2c-.1.4-.5.8-.9.9l-1.2.4c-.3.1-.5.4-.5.7 0 .3.2.6.5.7l1.2.4c.4.1.8.5.9.9l.4 1.3c.1.3.4.5.7.5.3 0 .6-.2.7-.5l.4-1.2c.1-.4.5-.8.9-.9l1.2-.4c.3-.1.5-.4.5-.7 0-.3-.2-.7-.5-.8Z',
      fillRule: 'evenodd',
      clipRule: 'evenodd'
    }
  ],
  name: 'sparkles',
  type: 'solid'
}
